import React, { useContext, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../../assets/css/gcadmin/manageusers/ManageUsers.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

/* ══════════════════════════════════════════
   Detail Modal (for Students & Staff)
══════════════════════════════════════════ */
const DetailModal = ({ user, isStaff, onClose }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const staffRows = [
    { label: "Full Name",   value: user.name },
    { label: "Email",       value: user.email },
    { label: "Phone",       value: user.phone },
    { label: "User ID",     value: user.userId },
    { label: "Status",      value: user.status },
  ];

  const studentRows = [
    { label: "Full Name",   value: user.fullName },
    { label: "Email",       value: user.email },
    { label: "Phone",       value: user.phone },
    { label: "Roll No",     value: user.roll_no },
    { label: "Program",     value: user.program },
    { label: "Session",     value: user.session },
    { label: "Status",      value: user.status ?? "Active" },
  ];

  const rows = isStaff ? staffRows : studentRows;

  return (
    <div className={`gcAdminMU-backdrop ${visible ? "gcAdminMU-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminMU-modal ${visible ? "gcAdminMU-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdminMU-modal-header">
          <h5 className="gcAdminMU-modal-title">User Details</h5>
          <button className="gcAdminMU-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className="gcAdminMU-modal-body">
          {rows.map(({ label, value }) => (
            <div className="gcAdminMU-detail-row" key={label}>
              <span className="gcAdminMU-detail-label">{label}</span>
              <span className={`gcAdminMU-detail-value ${value === "Active" ? "gcAdminMU-val--green" : value === "Suspended" ? "gcAdminMU-val--red" : ""}`}>
                {value ?? "—"}
              </span>
            </div>
          ))}
        </div>
        <div className="gcAdminMU-modal-footer-single">
          <button className="gcAdminMU-close-btn" onClick={handleClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   SubAdmin Detail Modal
══════════════════════════════════════════ */
const SubAdminDetailModal = ({ user, onClose }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const rows = [
    { label: "Full Name", value: user.name },
    { label: "Email", value: user.email },
    { label: "Role", value: user.role },
    { label: "Created", value: user.created_at ? new Date(user.created_at).toLocaleDateString() : "—" },
    { label: "Status", value: user.status ?? "Active" },
  ];

  return (
    <div className={`gcAdminMU-backdrop ${visible ? "gcAdminMU-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminMU-modal ${visible ? "gcAdminMU-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdminMU-modal-header">
          <h5 className="gcAdminMU-modal-title">Sub-Admin Details</h5>
          <button className="gcAdminMU-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className="gcAdminMU-modal-body">
          {rows.map(({ label, value }) => (
            <div className="gcAdminMU-detail-row" key={label}>
              <span className="gcAdminMU-detail-label">{label}</span>
              <span className={`gcAdminMU-detail-value ${value === "Active" ? "gcAdminMU-val--green" : value === "Suspended" ? "gcAdminMU-val--red" : ""}`}>
                {value ?? "—"}
              </span>
            </div>
          ))}
        </div>
        <div className="gcAdminMU-modal-footer-single">
          <button className="gcAdminMU-close-btn" onClick={handleClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Add Staff Modal
══════════════════════════════════════════ */
const StaffRegister = ({ onClose, loadAllTeacher }) => {
  const [visible, setVisible] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { baseUrl, authToken, validateTeacherRegisterForm } = useContext(AppContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const clearError = (field) => setErrors(prev => ({ ...prev, [field]: "" }));

  const RegisterTeacher = (e) => {
    e.preventDefault();

    const validationErrors = validateTeacherRegisterForm({ name, email, phone, password });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/teacherAuth/registerTeacher`, formData, {
        headers: { "Authorization": `Bearer ${authToken}` },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          Swal.fire({
            title: 'Success!',
            text: "Teacher Created Successfully",
            icon: 'success',
            confirmButtonText: 'Great'
          });
          onClose();
          loadAllTeacher();
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Registration failed." });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  return (
    <div className={`gcAdminMU-backdrop ${visible ? "gcAdminMU-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminMU-modal ${visible ? "gcAdminMU-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdminMU-modal-header">
          <h5 className="gcAdminMU-modal-title">Add New Staff Member</h5>
          <button className="gcAdminMU-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <form className="gcAdminMU-modal-body gcAdminMU-form-body">
          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Full Name</label>
            <input
              className={`gcAdminMU-form-input ${errors.name ? "gcAdminMU-form-input--error" : ""}`}
              type="text"
              placeholder="Enter full name"
              value={name}
              onChange={(e) => { setName(e.target.value); clearError("name"); }}
            />
            {errors.name && <span className="gcAdminMU-field-error">{errors.name}</span>}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Email</label>
            <input
              className={`gcAdminMU-form-input ${errors.email ? "gcAdminMU-form-input--error" : ""}`}
              type="email"
              placeholder="staff@example.com"
              value={email}
              onChange={(e) => { setEmail(e.target.value); clearError("email"); }}
            />
            {errors.email && <span className="gcAdminMU-field-error">{errors.email}</span>}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Phone</label>
            <input
              className={`gcAdminMU-form-input ${errors.phone ? "gcAdminMU-form-input--error" : ""}`}
              type="text"
              placeholder="03001234567"
              value={phone}
              onChange={(e) => { setPhone(e.target.value); clearError("phone"); }}
            />
            {errors.phone && <span className="gcAdminMU-field-error">{errors.phone}</span>}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Password</label>
            <div className="gcAdminMU-pass-wrap">
              <input
                className={`gcAdminMU-form-input gcAdminMU-form-input--pass ${errors.password ? "gcAdminMU-form-input--error" : ""}`}
                type={showPass ? "text" : "password"}
                placeholder="Set password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); clearError("password"); }}
              />
              <button type="button" className="gcAdminMU-pass-eye"
                onClick={() => setShowPass(s => !s)} tabIndex={-1}
                aria-label={showPass ? "Hide password" : "Show password"}>
                {showPass ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
            {errors.password && <span className="gcAdminMU-field-error">{errors.password}</span>}
          </div>

          <div className="gcAdminMU-modal-footer">
            <button type="button" className="gcAdminMU-save-btn" onClick={RegisterTeacher} disabled={loading}>
              {loading ? "Adding..." : "Add Staff"}
            </button>
            <button type="button" className="gcAdminMU-cancel-btn" onClick={handleClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Add Sub-Admin Modal
══════════════════════════════════════════ */
const SubAdminRegister = ({ onClose, loadAllSubAdmins }) => {
  const [visible, setVisible] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { baseUrl, authToken,   validateSubAdminRegisterForm ,regExpChecker,} = useContext(AppContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("Library Manager");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("Active");

  const roleOptions = ["Library Manager", "Content Manager", "Support Moderator"];
  const stateOptions = ["Active", "Disabled"];

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const clearError = (field) => setErrors(prev => ({ ...prev, [field]: "" }));

  

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateSubAdminRegisterForm({name,email,role,status, password,});
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setLoading(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("role", role);
    formData.append("password", password);
    formData.append("status", status);

    axios
      .post(`${baseUrl}/admin/auth/adminRegister`, formData, {
        headers: { "Authorization": `Bearer ${authToken}` },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          Swal.fire({ title: "Success!", text: "Sub-Admin created successfully", icon: "success", confirmButtonText: "Great" });
          onClose();
          loadAllSubAdmins();
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Registration failed." });
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  return (
    <div className={`gcAdminMU-backdrop ${visible ? "gcAdminMU-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminMU-modal ${visible ? "gcAdminMU-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdminMU-modal-header">
          <h5 className="gcAdminMU-modal-title">Add Sub-Admin</h5>
          <button className="gcAdminMU-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <form className="gcAdminMU-modal-body gcAdminMU-form-body">
          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Full Name</label>
            <input
              className={`gcAdminMU-form-input ${errors.name ? "gcAdminMU-form-input--error" : ""}`}
              type="text"
              placeholder="Enter full name"
              value={name}
              onChange={(e) => {

    const value = e.target.value;

    setName(value);

    setErrors(prev => ({
        ...prev,
        name: regExpChecker("fullName", value)
    }));

}}
            />
            {errors.name && (
    <small className="text-danger">
        {errors.name}
    </small>
)}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Email</label>
            <input
              className={`gcAdminMU-form-input ${errors.email ? "gcAdminMU-form-input--error" : ""}`}
              type="email"
              placeholder="subadmin@example.com"
              value={email}
              onChange={(e)=>{

    const value = e.target.value;

    setEmail(value);

    setErrors(prev=>({
        ...prev,
        email: regExpChecker("email", value)
    }));

}}
            />
            {errors.email && (
    <small className="text-danger">
        {errors.email}
    </small>
)}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Role</label>
            <div className="gcAdminMU-select-wrap">
              <select
                className={`gcAdminMU-form-select ${errors.role ? "gcAdminMU-form-input--error" : ""}`}
                value={role}
                onChange={(e)=>{

    setRole(e.target.value);

    setErrors(prev=>({
        ...prev,
        role: ""
    }));

}}
              >
                {roleOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
              <span className="gcAdminMU-select-arrow">▼</span>
            </div>
            {errors.role && (
    <small className="text-danger">
        {errors.role}
    </small>
)}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Status</label>
            <div className="gcAdminMU-select-wrap">
              <select
                className={`gcAdminMU-form-select ${errors.status ? "gcAdminMU-form-input--error" : ""}`}
                value={status}
                onChange={(e)=>{

    setStatus(e.target.value);

    setErrors(prev=>({
        ...prev,
        status: ""
    }));

}}
              >
                {stateOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
              <span className="gcAdminMU-select-arrow">▼</span>
            </div>
            {errors.status && (
    <small className="text-danger">
        {errors.status}
    </small>
)}
          </div>

          <div className="gcAdminMU-form-group">
            <label className="gcAdminMU-form-label">Password</label>
            <div className="gcAdminMU-pass-wrap">
              <input
                className={`gcAdminMU-form-input gcAdminMU-form-input--pass ${errors.password ? "gcAdminMU-form-input--error" : ""}`}
                type={showPass ? "text" : "password"}
                placeholder="Set password"
                value={password}
                onChange={(e)=>{

    const value = e.target.value;

    setPassword(value);

    setErrors(prev=>({
        ...prev,
        password: regExpChecker("password", value)
    }));

}}
              />
              {errors.password && (
    <small className="text-danger">
        {errors.password}
    </small>
)}
              <button type="button" className="gcAdminMU-pass-eye"
                onClick={() => setShowPass(s => !s)} tabIndex={-1}
                aria-label={showPass ? "Hide password" : "Show password"}>
                {showPass ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
            {errors.password && <span className="gcAdminMU-field-error">{errors.password}</span>}
          </div>

          <div className="gcAdminMU-modal-footer">
            <button type="button" className="gcAdminMU-save-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? "Adding..." : "Add Sub-Admin"}
            </button>
            <button type="button" className="gcAdminMU-cancel-btn" onClick={handleClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Suspend / Activate Confirm Modal (reusable)
══════════════════════════════════════════ */
const StatusModal = ({ user, isStaff, isSubAdmin, onClose, onConfirm }) => {
  const isSuspended = user.status === "Suspended";
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  let displayName = "";
  if (isSubAdmin) displayName = user.name;
  else if (isStaff) displayName = user.name;
  else displayName = user.fullName;

  return (
    <div className={`gcAdminMU-backdrop ${visible ? "gcAdminMU-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdminMU-modal gcAdminMU-modal--sm ${visible ? "gcAdminMU-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className={`gcAdminMU-status-icon ${isSuspended ? "gcAdminMU-status-icon--green" : "gcAdminMU-status-icon--red"}`}>
          {isSuspended ? (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
              <path d="M22 11.08V12a10 10 0 11-5.93-9.14" stroke="#1a9e72" strokeWidth="1.8" strokeLinecap="round" />
              <polyline points="22 4 12 14.01 9 11.01" stroke="#1a9e72" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#d63031" strokeWidth="1.8" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="#d63031" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          )}
        </div>
        <h5 className="gcAdminMU-delete-title">{isSuspended ? "Activate User?" : "Suspend User?"}</h5>
        <p className="gcAdminMU-delete-msg">
          {isSuspended
            ? <><strong>{displayName}</strong> will regain full access.</>
            : <><strong>{displayName}</strong> will lose access to the system.</>}
        </p>
        <div className="gcAdminMU-delete-actions">
          <button className="gcAdminMU-delete-cancel" onClick={handleClose}>Cancel</button>
          <button
            className={`gcAdminMU-status-confirm ${isSuspended ? "gcAdminMU-status-confirm--green" : "gcAdminMU-status-confirm--red"}`}
            onClick={() => { onConfirm(user.id); handleClose(); }}
          >
            {isSuspended ? "Activate" : "Suspend"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Reusable Table for Students & Staff
══════════════════════════════════════════ */
const UsersTable = ({ data, isStaff, rowVisible, onView, onStatus }) => (
  <div className="gcAdminMU-table-wrap">
    <table className="gcAdminMU-table">
      <thead>
        <tr className="gcAdminMU-thead-row">
          <th className="gcAdminMU-th">Name</th>
          <th className="gcAdminMU-th">Email</th>
          {isStaff && <th className="gcAdminMU-th">Phone</th>}
          {!isStaff && <th className="gcAdminMU-th">Roll No</th>}
          {!isStaff && <th className="gcAdminMU-th">Program</th>}
          <th className="gcAdminMU-th">Status</th>
          <th className="gcAdminMU-th gcAdminMU-th--center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((user, i) => (
          <tr
            key={user.id}
            className={`gcAdminMU-tr ${rowVisible[i] ? "gcAdminMU-tr--visible" : ""}`}
            style={{ transitionDelay: `${i * 0.06}s` }}
          >
            <td className="gcAdminMU-td gcAdminMU-td--name">
              {isStaff ? user.name : user.fullName}
            </td>
            <td className="gcAdminMU-td gcAdminMU-td--email">{user.email}</td>
            {isStaff && <td className="gcAdminMU-td gcAdminMU-td--phone">{user.phone}</td>}
            {!isStaff && <td className="gcAdminMU-td gcAdminMU-td--roll">{user.roll_no}</td>}
            {!isStaff && <td className="gcAdminMU-td gcAdminMU-td--program">{user.program}</td>}
            <td className="gcAdminMU-td">
              <span className={`gcAdminMU-status-badge ${
                (user.status ?? "Active") === "Active"
                  ? "gcAdminMU-status--active"
                  : "gcAdminMU-status--suspended"
              }`}>
                {user.status ?? "Active"}
              </span>
            </td>
            <td className="gcAdminMU-td gcAdminMU-td--center">
              <div className="gcAdminMU-actions">
                <button className="gcAdminMU-action-btn gcAdminMU-action-btn--view"
                  onClick={() => onView(user)} title="View Details">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.9" />
                  </svg>
                </button>

                <button
                  className={`gcAdminMU-action-btn ${
                    (user.status ?? "Active") === "Active"
                      ? "gcAdminMU-action-btn--suspend"
                      : "gcAdminMU-action-btn--activate"
                  }`}
                  onClick={() => onStatus(user)}
                  title={(user.status ?? "Active") === "Active" ? "Suspend" : "Activate"}
                >
                  {(user.status ?? "Active") === "Active" ? (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.9" />
                      <line x1="5.64" y1="5.64" x2="18.36" y2="18.36" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                    </svg>
                  ) : (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <path d="M22 11.08V12a10 10 0 11-5.93-9.14" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                      <polyline points="22 4 12 14.01 9 11.01" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </button>
              </div>
            </td>
          </tr>
        ))}

        {data.length === 0 && (
          <tr>
            <td colSpan={isStaff ? 5 : 6} className="gcAdminMU-td gcAdminMU-td--empty">
              No users found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

/* ══════════════════════════════════════════
   SubAdmin Table
══════════════════════════════════════════ */
const SubAdminTable = ({ data, rowVisible, onView, onStatus }) => (
  <div className="gcAdminMU-table-wrap">
    <table className="gcAdminMU-table">
      <thead>
        <tr className="gcAdminMU-thead-row">
          <th className="gcAdminMU-th">Full Name</th>
          <th className="gcAdminMU-th">Email</th>
          <th className="gcAdminMU-th">Role</th>
          <th className="gcAdminMU-th">Created</th>
          <th className="gcAdminMU-th">Status</th>
          <th className="gcAdminMU-th gcAdminMU-th--center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((user, i) => (
          <tr
            key={user.id}
            className={`gcAdminMU-tr ${rowVisible[i] ? "gcAdminMU-tr--visible" : ""}`}
            style={{ transitionDelay: `${i * 0.06}s` }}
          >
            <td className="gcAdminMU-td gcAdminMU-td--name">{user.name}</td>
            <td className="gcAdminMU-td gcAdminMU-td--email">{user.email}</td>
            <td className="gcAdminMU-td">{user.role}</td>
            <td className="gcAdminMU-td">{user.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}</td>
            <td className="gcAdminMU-td">
              <span className={`gcAdminMU-status-badge ${
                (user.status ?? "Active") === "Active"
                  ? "gcAdminMU-status--active"
                  : "gcAdminMU-status--suspended"
              }`}>
                {user.status ?? "Active"}
              </span>
            </td>
            <td className="gcAdminMU-td gcAdminMU-td--center">
              <div className="gcAdminMU-actions">
                <button className="gcAdminMU-action-btn gcAdminMU-action-btn--view"
                  onClick={() => onView(user)} title="View Details">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.9" />
                  </svg>
                </button>

                <button
                  className={`gcAdminMU-action-btn ${
                    (user.status ?? "Active") === "Active"
                      ? "gcAdminMU-action-btn--suspend"
                      : "gcAdminMU-action-btn--activate"
                  }`}
                  onClick={() => onStatus(user)}
                  title={(user.status ?? "Active") === "Active" ? "Suspend" : "Activate"}
                >
                  {(user.status ?? "Active") === "Active" ? (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.9" />
                      <line x1="5.64" y1="5.64" x2="18.36" y2="18.36" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                    </svg>
                  ) : (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <path d="M22 11.08V12a10 10 0 11-5.93-9.14" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                      <polyline points="22 4 12 14.01 9 11.01" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </button>
              </div>
            </td>
          </tr>
        ))}
        {data.length === 0 && (
          <tr>
            <td colSpan="6" className="gcAdminMU-td gcAdminMU-td--empty">
              No sub-admins found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

/* ══════════════════════════════════════════
   Main Page
══════════════════════════════════════════ */
const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

const ManageUsers = () => {
  const { baseUrl, authToken,  } = useContext(AppContext);

  const [activeTab, setActiveTab] = useState("students");
  const [students, setStudents] = useState([]);
  const [staff, setStaff] = useState([]);
  const [subadmins, setSubadmins] = useState([]);
  const [search, setSearch] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [showAddSubAdmin, setShowAddSubAdmin] = useState(false);
  const [viewUser, setViewUser] = useState(null);
  const [viewSubAdmin, setViewSubAdmin] = useState(null);
  const [statusUser, setStatusUser] = useState(null);
  const [visible, setVisible] = useState(false);
  const [rowVisible, setRowVisible] = useState([]);
  const [loadingStud, setLoadingStud] = useState(false);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [loadingSubAdmin, setLoadingSubAdmin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // pagination state

  // ── Har tab ka data sirf 1 dafa (pehli baar us tab par jane par) fetch ho,
  //    baar baar tab switch karne par dobara API call na ho ──
  const [loadedTabs, setLoadedTabs] = useState({ students: false, staff: false, subadmins: false });

  // ── Pagination / tab switch par sirf current page (10 records) ki
  //    "loading" dikhane ke liye — MyBooksPage (staff side) jaisa pattern ──
  const [viewLoading, setViewLoading] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  /* ── Fetch Teachers ── */
  const loadAllTeacher = () => {
    setLoadingStaff(true);
    axios
      .get(`${baseUrl}/admin/teacherAuth/loadAllTeacher`, {
        headers: { "Authorization": `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success === true) setStaff(res.data.teachers);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoadingStaff(false);
        setLoadedTabs(prev => ({ ...prev, staff: true }));
      });
  };

  /* ── Fetch Students ── */
  const loadAllStudents = () => {
    setLoadingStud(true);
    axios
      .get(`${baseUrl}/admin/studentAuth/loadAllStudents`, {
        headers: { "Authorization": `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success === true) setStudents(res.data.students);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoadingStud(false);
        setLoadedTabs(prev => ({ ...prev, students: true }));
      });
  };

  /* ── Fetch Sub-Admins ── */
  const loadAllSubAdmins = () => {
    setLoadingSubAdmin(true);
    axios
      .get(`${baseUrl}/admin/subadmin/list`, {
        headers: { "Authorization": `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success === true) setSubadmins(res.data.data);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoadingSubAdmin(false);
        setLoadedTabs(prev => ({ ...prev, subadmins: true }));
      });
  };

  /* ── Sirf jis tab par user click kare, usi ka data load ho.
     Agar tab pehle load ho chuka hai to dobara API call nahi hogi. ── */
  const loadTabData = (tab) => {
    if (loadedTabs[tab]) return;
    if (tab === "staff") loadAllTeacher();
    else if (tab === "subadmins") loadAllSubAdmins();
    else loadAllStudents();
  };

  // ── Sirf default/active tab (students) ka data mount par load hoga,
  //    baaki dono tabs ka data tab hi load hoga jab unhe click kiya jaye ──
  useEffect(() => {
    loadTabData("students");
    // eslint-disable-next-line
  }, []);

  const isStaff = activeTab === "staff";
  const isSubAdmin = activeTab === "subadmins";
  let currentData = [];
  if (isSubAdmin) currentData = subadmins;
  else if (isStaff) currentData = staff;
  else currentData = students;

  /* ── Search filter ── */
  const filtered = (currentData || []).filter((u) => {
    const q = search.toLowerCase();
    if (isSubAdmin) {
      return u.name?.toLowerCase().includes(q) ||
             u.email?.toLowerCase().includes(q) ||
             u.role?.toLowerCase().includes(q);
    } else if (isStaff) {
      return u.name?.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q);
    } else {
      return u.fullName?.toLowerCase().includes(q) ||
             u.email?.toLowerCase().includes(q) ||
             u.roll_no?.toLowerCase().includes(q);
    }
  });

  /* ── Pagination slice (sirf current page ka data table ko jayega) ── */
  const paginatedData = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Search ya tab change hone par page 1 pe reset ── */
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line
  }, [search, activeTab]);

  /* ── Row fade-in animation ab paginatedData ke hisaab se chalegi ── */
  useEffect(() => {
    setRowVisible([]);
    const timeouts = paginatedData.map((_, i) => {
      return setTimeout(() => {
        setRowVisible(prev => { const n = [...prev]; n[i] = true; return n; });
      }, i * 65);
    });
    return () => timeouts.forEach(timeout => clearTimeout(timeout));
    // eslint-disable-next-line
  }, [search, activeTab, currentPage, students, staff, subadmins]);

  /* ── Sirf visible (current page ke) records ki "loading" dikhayein:
     - Jab tab change ho (students/staff/subadmins)
     - Jab pagination se dusre page par jayen
     Is se sirf jitne records is waqt screen par show hone hain
     (max 10) unhi ki loading chalti hai, poori list ek sath nahi. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
  }, [activeTab, currentPage, search]);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setSearch("");
    setRowVisible([]);
    setCurrentPage(1);
    loadTabData(tab); // yahi par us tab ki loading trigger hogi (agar pehli baar hai)
  };

  /* ── Toggle Status (local only) ── */
  /* ── Toggle Status — real backend call ── */
const handleToggleStatus = (id) => {
  if (isStaff) {
    axios.post(`${baseUrl}/admin/teacherAuth/toggleStatus`, { teacher_id: id }, {
      headers: { "Authorization": `Bearer ${authToken}` },
    })
      .then((res) => {
        if (res.data.success) {
          setStaff(prev => prev.map(u => u.id === id ? res.data.teacher : u));
          Swal.fire({ icon: "success", title: "Updated", text: res.data.message, timer: 1500, showConfirmButton: false });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  } else if (isSubAdmin) {
    // Sub-admin status toggle stays local-only for now (no dedicated endpoint yet)
    setSubadmins(prev =>
      prev.map(u => u.id === id
        ? { ...u, status: (u.status ?? "Active") === "Active" ? "Suspended" : "Active" }
        : u
      )
    );
  } else {
    axios.post(`${baseUrl}/admin/studentAuth/toggleStatus`, { student_id: id }, {
      headers: { "Authorization": `Bearer ${authToken}` },
    })
      .then((res) => {
        if (res.data.success) {
          setStudents(prev => prev.map(u => u.id === id ? res.data.student : u));
          Swal.fire({ icon: "success", title: "Updated", text: res.data.message, timer: 1500, showConfirmButton: false });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  }
};

  /* ── isApiLoading: pehli baar us tab ka actual API call chal raha hai
     viewLoading: tab/page switch ki chhoti si (400ms) visual loading (data cached ho tab bhi) ── */
  const isApiLoading = isSubAdmin ? loadingSubAdmin : (isStaff ? loadingStaff : loadingStud);
  const showLoader = isApiLoading || viewLoading;

  const getSearchPlaceholder = () => {
    if (isSubAdmin) return "Search sub-admins...";
    if (isStaff) return "Search by name or email...";
    return "Search by name, email or roll no...";
  };

  return (
    <div className={`gcAdminMU-page ${visible ? "gcAdminMU-page--visible" : ""}`}>
      <Container fluid className="gcAdminMU-container">

        <div className="gcAdminMU-header">
          <h2 className="gcAdminMU-title">Manage Users</h2>
          {(isStaff || isSubAdmin) && (
            <button className="gcAdminMU-add-btn" onClick={() => isStaff ? setShowAdd(true) : setShowAddSubAdmin(true)}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
              </svg>
              {isStaff ? "Add Staff" : "Add Sub-Admin"}
            </button>
          )}
        </div>

        <div className="gcAdminMU-tabs">
          <button
            className={`gcAdminMU-tab ${activeTab === "students" ? "gcAdminMU-tab--active" : ""}`}
            onClick={() => switchTab("students")}
          >Students</button>
          <button
            className={`gcAdminMU-tab ${activeTab === "staff" ? "gcAdminMU-tab--active" : ""}`}
            onClick={() => switchTab("staff")}
          >Staff</button>
          <button
            className={`gcAdminMU-tab ${activeTab === "subadmins" ? "gcAdminMU-tab--active" : ""}`}
            onClick={() => switchTab("subadmins")}
          >Sub-Admins</button>
        </div>

        <div className="gcAdminMU-search-row">
          <div className="gcAdminMU-search-wrap">
            <input
              className="gcAdminMU-search-input"
              type="text"
              placeholder={getSearchPlaceholder()}
              value={search}
              onChange={e => { setSearch(e.target.value); setRowVisible([]); }}
            />
            <button className="gcAdminMU-search-btn" aria-label="Search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.9" />
                <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </div>

        {showLoader ? (
          <Loader
            message={`${isSubAdmin ? "Sub-admins" : (isStaff ? "Staff" : "Students")} Data Loading, Please wait...`}
          />
        ) : (
          <>
            {isSubAdmin ? (
              <SubAdminTable
                data={paginatedData}
                rowVisible={rowVisible}
                onView={setViewSubAdmin}
                onStatus={setStatusUser}
              />
            ) : (
              <UsersTable
                data={paginatedData}
                isStaff={isStaff}
                rowVisible={rowVisible}
                onView={setViewUser}
                onStatus={setStatusUser}
              />
            )}

            <Pagination
              currentPage={currentPage}
              totalItems={filtered.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setCurrentPage}
            />
          </>
        )}

      </Container>

      {showAdd && <StaffRegister onClose={() => setShowAdd(false)} loadAllTeacher={loadAllTeacher} />}
      {showAddSubAdmin && <SubAdminRegister onClose={() => setShowAddSubAdmin(false)} loadAllSubAdmins={loadAllSubAdmins} />}
      {viewUser && <DetailModal user={viewUser} isStaff={isStaff} onClose={() => setViewUser(null)} />}
      {viewSubAdmin && <SubAdminDetailModal user={viewSubAdmin} onClose={() => setViewSubAdmin(null)} />}
      {statusUser && <StatusModal user={statusUser} isStaff={isStaff} isSubAdmin={isSubAdmin} onClose={() => setStatusUser(null)} onConfirm={handleToggleStatus} />}
    </div>
  );
};

export default ManageUsers;